import React from 'react';
import { makeStyles } from '@material-ui/core';
import { SubmitButton } from '../UI';
import { AddIcon } from '../UI/Images/Icons';
import { PropTypes } from 'prop-types';

const style = makeStyles({
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingTop: 10,
        background: '#ffff',
        position: 'sticky',
        top: '-60px',
        right: '-24px',
        left: '-24px',
        zIndex: '50',
        height: '60px'
    },
    buttonWrapper: {
        minWidth: '130px'
    },
    buttonText: {
        padding: '0 8px'
    },
    title: {
        fontSize: '15px',
        fontWeight: 'bold'
    }
});

const FormAndClinicHeader = ({ title, buttonText, handleClick }) => {
    const classes = style();

    return (
        <div className={classes.header}>
            <h3 className={classes.title}> {title} </h3>

            <div className={classes.buttonWrapper}>
                <SubmitButton fullWith mr="0" disableSubmit handleClick={handleClick}>
                    <AddIcon className={classes.addIcon} width={18} height={18} fill={'#fff'} />
                    <div className={classes.buttonText}>{buttonText}</div>
                </SubmitButton>
            </div>
        </div>
    );
};
FormAndClinicHeader.propTypes = {
    title: PropTypes.function,
    buttonText: PropTypes.function,
    handleClick: PropTypes.function
};
export default FormAndClinicHeader;
